import { useState } from "react";
// useForm functional component
export const useForm = (callback, initialState = {}) => {
    const [values, setValues] = useState(initialState);
    // onChange
    const onChange = (event) => {
        setValues((values) => (Object.assign(Object.assign({}, values), { [event.target.name]: event.target.value })));
    };
    // onSubmit
    const onSubmit = (event) => {
        event.preventDefault();
        callback(event); // triggering the callback
    };
    // return values
    return {
        onChange,
        onSubmit,
        values,
    };
};
